<template>
  <SearchableDropdown
    v-model="selectedContentType"
    :name="name"
    class="m-b-10"
    :class="customClass"
    :config="contentTypeDropdownConfig"
    :clearable="false"
  />
</template>

<script>
import SearchableDropdown from '@/core/components/SearchableDropdown/SearchableDropdown';

export default {
  name: 'HttpContentTypeSelector',
  components: { SearchableDropdown },
  props: {
    name: {
      type: String,
      default: null,
    },
    value: {
      type: String,
      default: null
    },
    customClass: {
      type: String,
      default: ''
    },
  },
  computed: {
    contentTypeDropdownConfig() {
      return {
        options: [
          { label: 'application/json', id: 'application/json' },
          { label: 'application/xml', id: 'application/xml' },
          { label: 'application/x-www-form-urlencoded', id: 'application/x-www-form-urlencoded' },
          { label: 'text/plain', id: 'text/plain' },
        ],
        placeholder: 'Choose Content Type',
      };
    },
    selectedContentType: {
      get() {
        return this.contentTypeDropdownConfig.options.find( ({ id }) => id === this.value );
      },
      set(value) {
        this.$emit('input', value.id);
      }
    },
  }
};
</script>